import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useWeb3React } from "@web3-react/core";
import {
  addCondoTransaction,
  convertAddressToLowerCase,
  getConfigsFireStore,
  getEthStatingSlot,
  getRandomCondo,
  releaseCondo,
  updateCondoStatus,
} from "../../actions/DataActions";
import { mapIcon, towerEx } from "../../assets";
import {
  CHAIN,
  INVENTORY_TYPE,
  PAYMENT_SUPPORT,
  PLOT_STATUS,
} from "../../utils/constants/config";
import { AppContext } from "../walletsManagment/connectors";
import "./Modal.css";
import {
  buyCondo,
  checkNetwork,
  gerUserTokenBalance,
  getAllownceAmountToContract,
  getApproveAllownceAmountToContract,
  getPlotPrice,
} from "../../web3";
import ModalFailure from "./ModalFailure";
import LoaderComponent from "../../layout/LoaderComponent";
import messages from "../../utils/constants/messages";
// import FullImageView from "./FullImageView";

const CondoTower = ({ showModal, closeModal }) => {
  const [state, setState] = useState({
    loading: true,
    condoDetail: null,
    submitting: false,
    showErrorModal: false,
    plotPrice: null,
    showFundApprovalModal: false,
    intractionRemaingTime: 120,
    payment_support: PAYMENT_SUPPORT.TVK,
    isEventStarted: false,
  });
  const [fullView, setFullView] = useState(false);
  const refCurrenctSelectedPaymentSupprot = useRef();
  const { eithAuthToken, values } = useContext(AppContext);
  const { account, library } = useWeb3React();
  const refCountDownCancelTimer = useRef(null);
  const approvalDivRef = useRef(null);
  const inventoryType = "condos";

  useEffect(() => {
    if (!account) {
      const el = document.getElementById("wallet-connect-btn");
      el?.click();
      handleCloseModal(false);
    }
  }, [account]);
  useEffect(() => {
    window.onbeforeunload = handleRefresh;

    return () => {
      clearLockingTimmer();
      window.onbeforeunload = null;
    };
  }, []);
  const handleRefresh = () => {
    handleCloseModal(false);
  };

  const unLockCondo = () => {
    if (account && state.condoDetail?.condo_id) {
      try {
        releaseCondo(account, eithAuthToken, state.condoDetail?.id, values);
      } catch (error) {}
    }
  };
  const clearLockingTimmer = () => {
    if (refCountDownCancelTimer.current) {
      clearInterval(refCountDownCancelTimer.current);
      refCountDownCancelTimer.current = null;
    }
  };
  const updateIntervalTime = () => {
    setState((state) => {
      if (state.intractionRemaingTime < 30) {
        return {
          ...state,
          intractionRemaingTime: state.intractionRemaingTime + 30,
        };
      }
      return state;
    });
  };
  const startLockingTimmer = () => {
    if (account && state.isEventStarted) {
      refCountDownCancelTimer.current = setInterval(() => {
        setState((state) => {
          if (state.intractionRemaingTime <= 1) {
            handleCloseModal(false);
            return { ...state };
          } else {
            return {
              ...state,
              intractionRemaingTime: state.intractionRemaingTime - 1,
            };
          }
        });
      }, 1000);
    }
  };
  const getCondoDetail = async () => {
    try {
      setState((state) => ({ ...state, loading: true, condoDetail: null }));
      const configs = await getConfigsFireStore();
      const payment_support = configs?.payment_support || PAYMENT_SUPPORT.TVK;

      const condoDetail = await getRandomCondo(account, eithAuthToken, values);

      const slot = await getEthStatingSlot();
      let curTime = +new Date().getTime();
      let isEventStarted = false;

      if (curTime >= slot?.start_time) {
        isEventStarted = true;
      }

      setState((state) => ({
        ...state,
        loading: false,
        condoDetail: condoDetail.payload,
        plotPrice: null,
        payment_support: payment_support,
        tvkDiscount: configs?.tvk_discount || 0,
        ethDiscount: configs?.eth_discount || 0,
        isEventStarted,
      }));
    } catch (error) {
      console.log("===>", error);
      setState((state) => ({ ...state, loading: false, condoDetail: null }));

      setState((state) => ({
        ...state,
        submitting: false,
        showErrorModal: true,
        message:
          error?.response?.data?.message ??
          "Something went wrong please try again!",
      }));
    }
  };
  const isAllowEithBuy = () => {
    if (state.condoDetail?.remaining == 0) return false;
    return (
      state.isEventStarted &&
      (state.payment_support == PAYMENT_SUPPORT.EITH ||
        state.payment_support == PAYMENT_SUPPORT.BOTH) &&
      (state.condoDetail?.status == PLOT_STATUS.AVAILABLE ||
        (state.condoDetail?.owner_id == convertAddressToLowerCase(account) &&
          (state.condoDetail?.status == PLOT_STATUS.LOCKED ||
            state.condoDetail?.status == PLOT_STATUS.PROCESSING)))
    );
  };
  const isAllowTVKBuy = () => {
    if (state.condoDetail?.remaining == 0) return false;
    return (
      state.isEventStarted &&
      (state.payment_support == PAYMENT_SUPPORT.TVK ||
        state.payment_support == PAYMENT_SUPPORT.BOTH) &&
      (state.condoDetail?.status == PLOT_STATUS.AVAILABLE ||
        (state.condoDetail?.owner_id == convertAddressToLowerCase(account) &&
          (state.condoDetail?.status == PLOT_STATUS.LOCKED ||
            state.condoDetail?.status == PLOT_STATUS.PROCESSING)))
    );
  };

  useEffect(() => {
    if (showModal) getCondoDetail();
  }, [showModal, account]);

  useEffect(() => {
    if (state.condoDetail) {
      if (!refCountDownCancelTimer.current) startLockingTimmer();
    }
  }, [state.condoDetail]);

  const runBuyPlot = async (payment_support, eithMethodAmmount) => {
    setState((state) => ({ ...state, buying: true, processing: true }));

    try {
      const buyResponse = await buyCondo(
        account,
        1, //TODO  DYNAMIC SLOT
        state.condoDetail?.id,
        INVENTORY_TYPE.CONDO,
        state.condoDetail?.signature?.messageHash,
        state.condoDetail?.signature?.signature,
        payment_support,
        eithMethodAmmount,
        library
      );

      //TODO new responce
      if (
        buyResponse?.status == false &&
        (buyResponse?.response?.code == 4001 ||
          buyResponse?.response?.code == 3)
      ) {
        unLockCondo();

        throw {
          status: false,
          message:
            buyResponse?.response?.message ?? messages.pyamentRequestRejected,
        };
      } else if (
        buyResponse?.status == true &&
        (buyResponse?.response?.status == true ||
          buyResponse?.response?.startsWith("0x"))
      ) {
        await updateCondoStatus(
          state.condoDetail?.id,
          "PROCESSING",
          inventoryType,
          account,
          buyResponse.response?.blockHash || buyResponse.response
        );
        await addCondoTransaction(
          state.condoDetail?.id,
          "PROCESSING",
          account,
          buyResponse.response?.blockHash || buyResponse.response,
          state.condoDetail
        );
        setState((state) => ({ ...state, submitting: false }));
        handleCloseModal(true);
      } else {
        unLockCondo();
        throw {
          status: false,
          message:
            buyResponse?.response?.message ?? messages.pyamentRequestRejected,
        };
      }
    } catch (error) {
      unLockCondo();
      setState((state) => ({
        ...state,
        submitting: false,
        showErrorModal: true,
        message: error?.message ?? messages.pyamentRequestRejected,
      }));
    }
  };

  const startBuyProcess = async () => {
    setState((state) => ({ ...state, submitting: true }));
    clearLockingTimmer();
    try {
      await checkNetwork(library);
      const configs = await getConfigsFireStore();

      if (
        configs?.payment_support != PAYMENT_SUPPORT.BOTH &&
        refCurrenctSelectedPaymentSupprot.current != configs?.payment_support
      ) {
        throw {
          status: false,
          message: "Currently selected payment method is disabled. ",
        };
      }

      const balance = await gerUserTokenBalance(
        account,
        refCurrenctSelectedPaymentSupprot.current,
        library
      );
      if (balance == -1)
        throw { status: false, message: messages.invalid_network };
      const plotPrice = await getPlotPrice(
        INVENTORY_TYPE.CONDO,
        refCurrenctSelectedPaymentSupprot.current,
        library
      ); // (1 / state.condoDetail?.tvk_price_usd) * state.condoDetail.price;

      if (plotPrice == -1) throw { status: false };

      if (
        balance >= Number(plotPrice) &&
        refCurrenctSelectedPaymentSupprot.current == PAYMENT_SUPPORT.TVK
      ) {
        const allowenceAmmount = await getAllownceAmountToContract(
          account,
          library
        );

        if (Number(allowenceAmmount) >= Number(plotPrice) * 5) {
          // For fast mulitple trensactions(Pending form block) added check for 4 times of allownce amount
          await runBuyPlot(
            refCurrenctSelectedPaymentSupprot.current,
            plotPrice
          );
        } else {
          setTimeout(() => {
            approvalDivRef.current?.scrollIntoView({
              behavior: "smooth",
            });
          }, 2000);

          setState((state) => ({
            ...state,
            showFundApprovalModal: true,
            plotPrice: plotPrice,
          }));
        }
      } else if (
        balance >= Number(plotPrice) &&
        refCurrenctSelectedPaymentSupprot.current == PAYMENT_SUPPORT.EITH
      ) {
        await runBuyPlot(refCurrenctSelectedPaymentSupprot.current, plotPrice);
      } else {
        throw { status: false, message: messages.insufficient_funds };
      }
    } catch (error) {
      console.log("error:::", error);
      setState((state) => ({
        ...state,
        submitting: false,
        showErrorModal: true,
        message: error?.message ?? null,
      }));
    }
  };

  const getApproval = async () => {
    setState((state) => ({ ...state, showFundApprovalModal: false }));
    try {
      const approveStatus = await getApproveAllownceAmountToContract(
        account,
        state.plotPrice,
        library
      );
      if (approveStatus.status == true) {
        await runBuyPlot(
          refCurrenctSelectedPaymentSupprot.current,
          state.plotPrice
        );
      } else {
        setState((state) => ({ ...state, submitting: false }));

        handleCloseModal(false);
      }
    } catch (error) {
      console.log("--->>", error);

      setState((state) => ({
        ...state,
        submitting: false,
        showErrorModal: true,
        message: error?.code == 4001 ? "Approval request rejected." : null,
      }));
    }
  };
  const handleBuyNow = (payment_support) => {
    refCurrenctSelectedPaymentSupprot.current = payment_support;
    if (account) {
      if (isAllowEithBuy() || isAllowTVKBuy()) {
        startBuyProcess();
      }
    } else {
      document.getElementById("wallet-connect-btn")?.click();
      handleCloseModal(false);
    }
  };

  const handleCloseModal = (success) => {
    if (success) {
      closeModal(true);
    } else {
      setState((state) => {
        // if (
        //   state.condoDetail?.status === PLOT_STATUS.LOCKED &&
        //   state.processing == false &&
        //   account &&
        //   account === state.condoDetail?.owner_id
        // ) {
        unLockCondo();
        // }
        closeModal(false);
        return { ...state };
      });
    }
  };

  const handleFullView = () => {
    setFullView(true);
  };

  return (
    <>
      <Modal
        show={showModal}
        animation={false}
        contentClassName={"modal-content customPopup condoTower"}
        dialogClassName={
          state.showErrorModal
            ? "modal-dialog modal-dialog-centered invisible"
            : "modal-dialog modal-dialog-centered"
        }
        size="xl"
      >
        {/* CONDO TOWER */}

        <div className="">
          <button
            onClick={() => {
              handleCloseModal(false);
            }}
            className="close"
          >
            {/* <img src={close} alt="close-modal" /> */}
          </button>

          <div className="content inventoryCol">
            <div className="row">
              {state.loading ? (
                <div className="col-12 modal-screen-loader">
                  <LoaderComponent />
                </div>
              ) : (
                <>
                  <div className="col-sm-12 column">
                    <div className="plotImg">
                      {state.condoDetail?.remaining && (
                        <span className="plotCap">
                          Only {state.condoDetail?.remaining} Left
                        </span>
                      )}
                      <img
                        // onClick={handleFullView}
                        src={towerEx}
                        alt="your plot"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 offsetColumn">
                    {/* {state.loading ? (
                  <div className="d-flex justify-content-center align-items-center  h-100 w-100">
                    <LoaderComponent />
                  </div>
                ) : ( */}
                    <div className="plotInfo">
                      <div className="topInfo">
                        <h3 className="title title-sm">
                          {state.condoDetail?.tower}
                        </h3>
                        <h4 className="title title-sm price">
                          ${state.condoDetail?.price}
                        </h4>

                        <ul className="listing">
                          <li>
                            <div>Floors</div>
                            <p className="numClr">
                              {state.condoDetail?.total_floors}
                            </p>
                          </li>
                          <li>
                            <div>Condos</div>
                            <p className="numClr">
                              {state.condoDetail?.total_condos}
                            </p>
                          </li>

                          <li>
                            <div>Blockchain</div>
                            <p>Ethereum</p>
                          </li>
                        </ul>
                      </div>
                      <div className="bottomInfo">
                        <div className="location">
                          <img src={mapIcon} alt="" />
                          <span className="place">Monster Zone</span>
                        </div>
                        <div className="w-100 button-groups ">
                          <div className="buttonTxt">
                            <button
                              disabled={state.submitting || !isAllowTVKBuy()}
                              className={
                                isAllowTVKBuy()
                                  ? state.submitting
                                    ? `custom-btn accent-bg lg bg-transparent`
                                    : `custom-btn accent-bg lg`
                                  : `custom-btn accent-bg lg bg-transparent`
                              }
                              onClick={() => handleBuyNow(PAYMENT_SUPPORT.TVK)}
                            >
                              {state.submitting &&
                              refCurrenctSelectedPaymentSupprot.current ==
                                PAYMENT_SUPPORT.TVK ? (
                                <>
                                  <Spinner size="sm" className=" mx-2 " />{" "}
                                  Verifying
                                </>
                              ) : account ? (
                                "BUY WITH TVK"
                              ) : (
                                "Connect Wallet"
                              )}
                            </button>
                            <p className="footNote">
                              {(state.payment_support == PAYMENT_SUPPORT.TVK ||
                                state.payment_support ==
                                  PAYMENT_SUPPORT.BOTH) &&
                                state.tvkDiscount > 0 &&
                                account &&
                                state.tvkDiscount + "% discount with TVK"}
                            </p>
                          </div>
                          <div className="buttonTxt">
                            <button
                              disabled={state.submitting || !isAllowEithBuy()}
                              className={
                                isAllowEithBuy()
                                  ? state.submitting
                                    ? `custom-btn accent-bg lg bg-transparent`
                                    : `custom-btn accent-bg lg`
                                  : `custom-btn accent-bg lg ${
                                      account ? "bg-transparent" : "d-none"
                                    } mx-1 px-0 `
                              }
                              onClick={() => handleBuyNow(PAYMENT_SUPPORT.EITH)}
                            >
                              {state.submitting &&
                              refCurrenctSelectedPaymentSupprot.current ==
                                PAYMENT_SUPPORT.EITH ? (
                                <>
                                  <Spinner size="sm" className=" mx-2 " />{" "}
                                  Verifying
                                </>
                              ) : account ? (
                                "BUY WITH ETH"
                              ) : (
                                "Connect Wallet"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                  <div className="col-12">
                    {!state.submitting && (
                      <div className="mobile-btn">
                        <button
                          onClick={() => {
                            handleCloseModal(false);
                          }}
                          className="custom-btn gray-bg lg"
                        >
                          Close
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    {state.isEventStarted ? (
                      <div
                        className={`verifying ${
                          state.intractionRemaingTime &&
                          refCountDownCancelTimer.current
                            ? ""
                            : "d-none"
                        }`}
                      >
                        <div className="timer">Time Remaining:</div>
                        <span className="buy-lock-time">
                          {state.intractionRemaingTime} Seconds
                        </span>
                      </div>
                    ) : (
                      <div className="verifying">
                        {messages.event_not_started}
                      </div>
                    )}

                    <div
                      className={
                        state.showFundApprovalModal ? "confirmation" : "d-none"
                      }
                    >
                      <div className="text">
                        <h2 className="title">Transaction Approval</h2>
                        <p className="">
                          Please grant approval to use{" "}
                          <b>{Number(state.plotPrice ?? 0)?.toFixed(2)}</b> TVK
                          from your account for purchasing.
                        </p>
                      </div>
                      <div className="button-groups" ref={approvalDivRef}>
                        <button
                          className="custom-btn lg accent-bg"
                          onClick={getApproval}
                        >
                          Approve
                        </button>
                        <button
                          className="custom-btn lg gray-bg"
                          onClick={() => {
                            handleCloseModal(false);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <ModalFailure
            showModal={state.showErrorModal}
            message={state.message}
            closeModal={() => {
              handleCloseModal(false);
            }}
          />
          {/* <FullImageView
            showModal={fullView}
            viewImage={towerEx}
            closeModal={() => {
              setFullView(false);
            }}
          /> */}
        </div>
      </Modal>
    </>
  );
};

export default CondoTower;
